/**
 * Solo los ids, sin los SVG: el selector necesita saber de forma sincrona si un icono existe, y
 * `VenueIcon.type.ts` pesa ~160 kB y se carga en diferido. Un spec comprueba que no divergen.
 */
export const VENUE_ICON_IDS: readonly string[] = [
  'basketball',
  'football-soccer',
  'baseball',
  'american-football',
  'volleyball',
  'badminton',
  'bowling',
  'boxer',
  'climbing',
  'cycling',
  'darts',
  'formula-1',
  'field-hockey',
  'golf',
  'gymnastics',
  'handball',
  'horse-racing',
  'ice-hockey',
  'ice-skate',
  'martial-arts',
  'motogp',
  'paddle',
  'polo',
  'swimming',
  'tennis',
  'tour-france',
  'wrestling',
  'center-stage-ga',
  'cinema',
  'circus',
  'front-stage-seats',
  'ga-pit',
  'main-stage-festival',
  'opera',
  'rectangle-tables',
  'round-tables',
  'second-stage-festival',
  'theatre',
  'vip-locations-festival',
  'center-stage-seats',
];
